<template>
  <div class="exit_phone">
    <back-step
      :goList="[{
        url: '/',
        name: `${$t('home.personal.personal.zy')}`
      }, {
        url: '/home/personal',
        name: `${$t('home.personal.personal.grzx')}`
      }]"
      :currentTxt="`${$t('home.personal.bandPhone.bdsj')}`"
    />
    <div class="children_con" v-if="!isExitOk">
      <h5 class="c_con_title">{{$t('home.personal.bandPhone.bdsj')}}</h5>
      <ul class="c_form">
        <li class="f_single">
          <span class="s_label">{{$t('home.personal.bandPhone.sjh')}}</span>
          <div class="iup_box">
            <input type="number" v-model="bindConfig.mobile">
          </div>
        </li>
        <li class="f_single">
          <span class="s_label">{{$t('home.personal.bandPhone.yzm')}}</span>
          <div class="iup_box">
            <input type="number" v-model="bindConfig.smsCaptcha">
            <span
              class="yzm_sp"
              :class="isYzm ? 'yzm_sp_active' : ''"
              @click="getYzm"
            >{{isYzm ? `${$t('home.personal.bandEmail.cxhq')} ${yzmTime}s` : `${$t('home.personal.bandEmail.hqyzm')}`}}</span>
          </div>
        </li>
      </ul>
      <div class="c_foo">
        <div class="main_big_btn mr20 main_theme_color_btn_white" @click="goBack">{{$t('common.message.qx')}}</div>
        <div class="main_big_btn main_theme_color_btn" @click="submitForm">{{$t('common.message.qd')}}</div>
      </div>
    </div>
    <exit-success
      v-else
      :isExitOk="isExitOk"
      :successTit="`${$t('common.message.bdcg')}`"
      :successTxt="`${$t('common.message.sjhbdcg')}`"
    />
    <FullLoading v-show="isLoading"/>
  </div>
</template>

<script>
  import BackStep from '../../../cases/cases-detail/childrenPublic/backStep';
  import ExitSuccess from './exitSuccess';
  import FullLoading from 'components/full-loading/full-loading';
  import {bindMobile, sendCaptcha} from 'common/api/user';
  import {notifyMsg, getUserId} from 'common/js/util';
  export default {
    data() {
      return {
        isLoading: false,
        isExitOk: false,
        isYzm: false,
        yzmTime: 59,
        interTime: null,
        bindConfig: {
          mobile: '',
          smsCaptcha: ''
        }
      }
    },
    methods: {
      getYzm() {
        if(this.isYzm) {
          return false;
        }
        const {mobile} = this.bindConfig;
        if(!mobile || !/^1[3|4|5|6|7|8|9]\d{9}$/.test(mobile)) {
          return notifyMsg(this, 'warning', this.$t('common.message.qtxzqsj'));
        }
        if(this.interTime) {
          clearInterval(this.interTime);
        }
        this.isLoading = true;
        sendCaptcha({
          bizType: 'BIND_MOBILE',
          mobile
        }).then(() => {
          this.isLoading = false;
          this.isYzm = true;
          this.interTime = setInterval(() => {
            if(this.yzmTime < 1) {
              this.isYzm = false;
              this.yzmTime = 59;
              clearInterval(this.interTime);
            }
            this.yzmTime--;
          }, 1000);
        }).catch(() => {
          this.isLoading = false;
        });
      },
      submitForm() {
        const {mobile, smsCaptcha} = this.bindConfig;
        if(!mobile || !smsCaptcha) {
          return notifyMsg(this, 'warning', this.$t('common.message.qtxwz'));
        }else if(!/^1[3|4|5|6|7|8|9]\d{9}$/.test(mobile)) {
          return notifyMsg(this, 'warning', this.$t('common.message.qtxzqsj'));
        }
        this.isLoading = true;
        bindMobile({
          id: getUserId(),
          mobile,
          smsCaptcha
        }).then(() => {
          this.isLoading = false;
          this.isExitOk = true;
        }).catch(() => {
          this.isLoading = false;
        });
      },
      goBack() {
        window.history.go(-1);
      }
    },
    components: {
      BackStep,
      ExitSuccess,
      FullLoading
    },
    beforeDestroy() {
      if(this.interTime) {
        clearInterval(this.interTime);
      }
    }
  }
</script>

<style scoped lang="scss">
  .exit_phone{
    width: 16rem;
    margin: 0 auto;
    padding-top: 40px;
    span{
      display: inline-block;
      cursor: pointer;
    }
    .children_con{
      border-radius: 6px;
      background-color: #fff;
      display: flex;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      .c_con_title{
        font-size: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 0.6rem;
        color: $main_theme_color_333;
        border-bottom: 1px solid #E5E5E5;
      }
      .c_form{
        width: 5.44rem;
        margin-top: 0.6rem;
        margin-bottom: 0.6rem;
        .f_single{
          display: flex;
          align-items: center;
          margin-bottom: 0.4rem;
          .s_label{
            width: 0.8rem;
            margin-right: 0.1rem;
            white-space: nowrap;
            display: flex;
            flex-flow: row-reverse;
            font-size: 16px;
            color: $main_theme_color_333;
          }
          .iup_box{
            flex: 1;
            display: flex;
            align-items: center;
            position: relative;
            height: 0.52rem !important;
            input {
              flex: 1;
              border-radius: 4px;
              border: 0.01rem solid #BBBBBB;
              padding: 16px 20px;
              font-size: 14px;
              color: $main_theme_color_333;
            }
            .yzm_sp {
              margin-left: 0.1rem;
              width: 1.2rem;
              height: 0.4rem;
              border-left: 1px solid #E5E5E5;
              color: $main_theme_color;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              right: 0;
              cursor: pointer;
              font-size: 14px;
            }
            .yzm_sp_active {
              color: $main_theme_color_666;
              cursor: default;
            }
          }
        }
      }
    }
    .c_foo{
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 0.6rem;
    }
  }
</style>
